(function () {
  'use strict';
  if (window.FannifenTierCart) return;
  function state(subtotal) {
    var tiers = [[280000, 15000], [450000, 30000], [680000, 50000]];
    var tier = tiers.find(function (t) { return subtotal < t[0]; }) || tiers[2];
    return {gap: Math.max(0, tier[0] - subtotal), saving: tier[1], top: subtotal >= 680000, progress: Math.min(100, subtotal / tier[0] * 100)};
  }
  function update(cart) {
    if (!/^(www\.)?fannifen\.cz$/.test(window.location.hostname) || cart.currency !== 'CZK') return false;
    var bars = document.querySelectorAll('[data-fannifen-tier-cart]');
    var subtotal = Number(cart.items_subtotal_price);
    if (!bars.length || !Number.isFinite(subtotal) || subtotal < 0) return false;
    var tier = state(subtotal);
    bars.forEach(function (bar) {
      var locale = bar.dataset.locale || 'en';
      var money = new Intl.NumberFormat(locale, {style: 'currency', currency: 'CZK'});
      var text = tier.top ? bar.dataset.top : bar.dataset.next;
      var message = bar.querySelector('[data-tier-message]');
      message.replaceChildren();
      text.split(/(\[gap\]|\[saving\])/).forEach(function (part) {
        if (part === '[gap]' || part === '[saving]') {
          var number = document.createElement('span');
          number.style.color = '#c62828';
          number.textContent = money.format((part === '[gap]' ? tier.gap : tier.saving) / 100);
          message.appendChild(number);
        } else message.appendChild(document.createTextNode(part));
      });
      bar.querySelector('[data-tier-progress]').style.width = tier.progress + '%';
      bar.dataset.subtotal = String(subtotal);
    });
    return true;
  }
  window.FannifenTierCart = {update: update};
  var initial = document.querySelector('[data-fannifen-tier-cart]');
  if (initial) update({currency: 'CZK', items_subtotal_price: Number(initial.dataset.subtotal)});
}());
